module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/introduction_primary_computing-1f85ca79c21fdffaf4f14ca9195bf6bf.jpeg";